<template>
  <span
    v-if="mark && variant === 'badge'"
    class="flex-none inline-flex items-center justify-center rounded-full pointer-events-none z-[1]"
    :style="{ background: mark.fg, width: size, height: size, boxShadow: '0 0 0 1.5px #fff' }"
    :title="mark.title"
    role="img"
    :aria-label="mark.title"
  >
    <i class="pi text-white" :class="mark.icon" :style="{ fontSize: `calc(${size} * 0.55)`, fontWeight: 700 }" />
  </span>
  <span
    v-else-if="mark"
    class="flex-none inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap"
    :style="{ background: mark.bg, color: mark.fg, fontSize: '10px', padding: '2px 8px' }"
    :title="mark.title"
  >
    <i class="pi" :class="mark.icon" style="font-size: 0.6rem; font-weight: 700" />
    {{ mark.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ICalendarEvent } from '@torim-app/types';
import { getAppointmentStatusMark } from './appointment-status-mark';

/**
 * `badge`: a solid disc for the calendar grids, pinned by the parent to the block's end
 * corner (left, RTL) — away from the name and its inline flags, so it can't be confused
 * with the "paid" ✓. `pill`: a labelled chip for list rows.
 *
 * The template must keep exactly ONE root element (no root-level comments either): the
 * parent positions the badge through `class`, and a fragment root silently drops it.
 */
const props = withDefaults(defineProps<{
  event: ICalendarEvent;
  /** Disc diameter for the `badge` variant. */
  size?: string;
  variant?: 'badge' | 'pill';
}>(), {
  size: '1.125rem',
  variant: 'badge',
});

const mark = computed(() => getAppointmentStatusMark(props.event));
</script>
